export const MODAL_Z_INDEX = 11000; // Higher than z-index of the share form modal on the form page(10000)
